// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/library_release.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CompareLibrarySourceChangeRequest, CompareLibrarySourceChangeResponse, CorrectLibrarySourceRequest, CorrectLibrarySourceResponse, CreateLibraryReuseRequest, CreateLibraryReuseResponse, EditAdoptedLibraryReuseRequest, EditAdoptedLibraryReuseResponse, GetCustomerContextRequest, GetCustomerContextResponse, GetLibraryWorkingSourceRequest, GetLibraryWorkingSourceResponse, GetReleasedDerivativeRequest, GetReleasedDerivativeResponse, ListCustomerContextsRequest, ListCustomerContextsResponse, ListLibraryReleaseHistoryRequest, ListLibraryReleaseHistoryResponse, ListLibraryReusesRequest, ListLibraryReusesResponse, ListSelectableReleasesRequest, ListSelectableReleasesResponse, PreviewCustomerContextRequest, PreviewCustomerContextResponse, ReleaseCustomerContextRequest, ReleaseCustomerContextResponse, ReleaseLibraryItemRequest, ReleaseLibraryItemResponse, ResolveLibraryReuseRequest, ResolveLibraryReuseResponse, ReviewLibrarySourceChangeRequest, ReviewLibrarySourceChangeResponse, WithdrawLibraryReleaseRequest, WithdrawLibraryReleaseResponse } from "./library_release_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * LibraryReleaseService is the browser edge for SAD-461 / SAD-462: release,
 * withdraw and live / adopted / frozen reuse. Each RPC wraps pangaea's
 * LibraryReleaseGatewayService; the viewer (user_id/company_id) is resolved
 * from the session, never trusted from the body.
 *
 * @generated from service mono.projectdata.v1.LibraryReleaseService
 */ export const LibraryReleaseService = {
    typeName: "mono.projectdata.v1.LibraryReleaseService",
    methods: {
        /**
     * SHAPE-04: explicit bounded customer context, never raw source discovery.
     *
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.PreviewCustomerContext
     */ previewCustomerContext: {
            name: "PreviewCustomerContext",
            I: PreviewCustomerContextRequest,
            O: PreviewCustomerContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ReleaseCustomerContext
     */ releaseCustomerContext: {
            name: "ReleaseCustomerContext",
            I: ReleaseCustomerContextRequest,
            O: ReleaseCustomerContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.GetCustomerContext
     */ getCustomerContext: {
            name: "GetCustomerContext",
            I: GetCustomerContextRequest,
            O: GetCustomerContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ListCustomerContexts
     */ listCustomerContexts: {
            name: "ListCustomerContexts",
            I: ListCustomerContextsRequest,
            O: ListCustomerContextsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ReleaseLibraryItem publishes version N+1 of an item (a source edit is a
     * re-release). Requires release_library_item on the item's source scope.
     *
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ReleaseLibraryItem
     */ releaseLibraryItem: {
            name: "ReleaseLibraryItem",
            I: ReleaseLibraryItemRequest,
            O: ReleaseLibraryItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.WithdrawLibraryRelease
     */ withdrawLibraryRelease: {
            name: "WithdrawLibraryRelease",
            I: WithdrawLibraryReleaseRequest,
            O: WithdrawLibraryReleaseResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetReleasedDerivative is the audience read of an item's current release.
     *
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ListLibraryReleaseHistory
     */ listLibraryReleaseHistory: {
            name: "ListLibraryReleaseHistory",
            I: ListLibraryReleaseHistoryRequest,
            O: ListLibraryReleaseHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.GetReleasedDerivative
     */ getReleasedDerivative: {
            name: "GetReleasedDerivative",
            I: GetReleasedDerivativeRequest,
            O: GetReleasedDerivativeResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListSelectableReleases lists non-withdrawn releases the caller's
     * audience membership reaches (no content).
     *
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ListSelectableReleases
     */ listSelectableReleases: {
            name: "ListSelectableReleases",
            I: ListSelectableReleasesRequest,
            O: ListSelectableReleasesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.CreateLibraryReuse
     */ createLibraryReuse: {
            name: "CreateLibraryReuse",
            I: CreateLibraryReuseRequest,
            O: CreateLibraryReuseResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ResolveLibraryReuse
     */ resolveLibraryReuse: {
            name: "ResolveLibraryReuse",
            I: ResolveLibraryReuseRequest,
            O: ResolveLibraryReuseResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.EditAdoptedLibraryReuse
     */ editAdoptedLibraryReuse: {
            name: "EditAdoptedLibraryReuse",
            I: EditAdoptedLibraryReuseRequest,
            O: EditAdoptedLibraryReuseResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ListLibraryReuses
     */ listLibraryReuses: {
            name: "ListLibraryReuses",
            I: ListLibraryReusesRequest,
            O: ListLibraryReusesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.GetLibraryWorkingSource
     */ getLibraryWorkingSource: {
            name: "GetLibraryWorkingSource",
            I: GetLibraryWorkingSourceRequest,
            O: GetLibraryWorkingSourceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.CorrectLibrarySource
     */ correctLibrarySource: {
            name: "CorrectLibrarySource",
            I: CorrectLibrarySourceRequest,
            O: CorrectLibrarySourceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.CompareLibrarySourceChange
     */ compareLibrarySourceChange: {
            name: "CompareLibrarySourceChange",
            I: CompareLibrarySourceChangeRequest,
            O: CompareLibrarySourceChangeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.LibraryReleaseService.ReviewLibrarySourceChange
     */ reviewLibrarySourceChange: {
            name: "ReviewLibrarySourceChange",
            I: ReviewLibrarySourceChangeRequest,
            O: ReviewLibrarySourceChangeResponse,
            kind: MethodKind.Unary
        }
    }
};
